import { LoaderWrap, Hourglass, Label } from "./InlineLoaderStyles";

export default function InlineLoader({ show, label = "Loading…" }) {
  if (!show) return null;

  return (
    <LoaderWrap role="status" aria-live="polite">
      <Hourglass aria-hidden="true" />
      {label ? <Label>{label}</Label> : null}
    </LoaderWrap>
  );
}
